import React, { useEffect, useState } from "react";
import { AchievementDivider, TrashIcon } from "../utils/icons";
import { getS3Media } from "../services/awsServices";

function AchievementBox({ data, onDeleteItem }) {
  const [pdfUrls, setPdfUrls] = useState([]);

  useEffect(() => {
    // Fetch PDF URLs for each item
    const fetchPdfUrls = async () => {
      const urls = await Promise.all(
        data[0]?.Data?.map(async (item) => {
          if (item.Attachments) {
            const res = await getS3Media(item.Attachments);
            return res?.data.url;
          }
          return null;
        })
      );
      if (!urls.includes("undefined")) {
        console.log("🚀 ~ fetchPdfUrls ~ urls:", urls);
        setPdfUrls(urls);
      }
    };

    fetchPdfUrls();
  }, [data]);

  return (
    <div>
      {data[0]?.Data.map((items, i) => {
        return (
          <div
            key={i}
            className="mt-5 space-y-2 transition-transform duration-500 ease-in-out transform hover:translate-x-1"
          >
            <div className="flex items-center justify-between">
              <div className="flex gap-3 items-center">
                <h1 className="text-lg text-black font-semibold">
                  {items?.Name}
                </h1>
                {items?.SK && (
                  <p className="font-semibold bg-gradient3 px-3 py-1 rounded-xl">
                    {items?.SK}
                  </p>
                )}
              </div>
              <div className="space-x-2">
                {/* <button>
          <PencilSquareSolid />
        </button> */}
                <button onClick={() => onDeleteItem(i)}>
                  <TrashIcon />
                </button>
              </div>
            </div>
            <h1>{items?.Rank}</h1>
            <h1>{items?.Description}</h1>
            {items?.ContactOfOrganization && (
              <h1>
                <span className="font-semibold">Contact Of Organization:</span>{" "}
                {items?.ContactOfOrganization}
              </h1>
            )}
            <div className="flex gap-5">
              <div>
                {pdfUrls && (
                  <a
                    href={pdfUrls}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-secondary5"
                  >
                    View Certification
                  </a>
                )}
                <div className="flex gap-3">
                  <p className="text-DarkGrey">{items?.Country}</p>
                  <p className="text-DarkGrey">{items?.City}</p>
                </div>
              </div>
              <p className="text-secondary3">{items?.Date}</p>
            </div>
            <AchievementDivider />
          </div>
        );
      })}
    </div>
  );
}

export default AchievementBox;
